import { useSearchParams } from 'react-router-dom';

// const constructPlangridRedirectUrl = () => {
//     return import.meta.env.VITE_APP_AUTH_REDIRECT_URL + '/microsoft-authenticate';
// };

// const MicrosoftIllustration = () => {
//     return (
//         <div className="flex items-center gap-5">
//             <img className="h-10" src="/logos/logo.png" alt="progressCenter" />
//             <BrokenLinkIcon />
//             <img className="h-10" src="/plugins-images/microsoft.svg" alt="Microsoft" />
//         </div>
//     );
// };

const MicrosoftAuthenticatePage = () => {
    const [searchParams] = useSearchParams();

    const token = searchParams.get('t');
    const hasMultipleAccounts = JSON.parse(searchParams.get('hM'));

    // const redirectUri = constructPlanGridRedirectUrl();
    // const { url } = JSON.parse(decodeURIComponent(state));

    // const microsoftQuery = useQuery({
    //     queryKey: ['microsoft-authenticate', code, redirectUri],
    //     queryFn: () => authenticateMicrosoft({ code, redirectUri }),
    //     retry: 0,
    // });

    if (token) {
        const expiryInMinutes = 90 * 24 * 60; // 90 days

        if (hasMultipleAccounts) {
            const redirectUrl = new URL('/choose-account', window.location.origin);
            redirectUrl.searchParams.set('t', token?.toString());
            redirectUrl.searchParams.set('e', expiryInMinutes.toString());

            window.location.href = redirectUrl.toString();
        } else {
            const redirectUrl = new URL('/token-login', window.location.origin);
            redirectUrl.searchParams.set('t', token?.toString());
            redirectUrl.searchParams.set('e', expiryInMinutes.toString());

            window.location.href = redirectUrl.toString();
        }
    }
    return <></>;

    // if (microsoftQuery.isLoading) {
    //     return (
    //         <section>
    //             <div className="fixed top-0 left-0 flex flex-col items-center justify-center h-screen w-full bg-card-color">
    //                 <div className="flex items-center justify-center w-14 h-14 rounded-lg text-primary ">
    //                     <CircularProgress size={32} />
    //                 </div>
    //             </div>
    //         </section>
    //     );
    // }

    // if (microsoftQuery.error) {
    //     return (
    //         <IllustrationView
    //             className="justify-center h-screen"
    //             illustration={<MicrosoftIllustration />}
    //             title="Microsoft Authentication Failed"
    //             message={
    //                 <>
    //                     We couldn’t connect to your Microsoft account. Please check your credentials or try again.
    //                     <div className="mt-2">
    //                         <Link to={url} replace className="text-primary font-medium cursor-pointer">
    //                             Back to home
    //                         </Link>
    //                     </div>
    //                 </>
    //             }
    //         />
    //     );
    // }
};

export default MicrosoftAuthenticatePage;
